import React from "react"

import { withPackages } from "./withPackages"
import { StyledColumn } from "../../../Styled/Column"
import { StyledRow } from "../../../Styled/Row"
import { H5, P } from "../../../Styled/Text"
import { Section, Title, Content, Cost, Pricing, Rule } from "./PackagesStyles"

export const Packages = withPackages(
  ({ locales, packages, title }): JSX.Element => (
    <Section>
      <H5 colour={`navy`} italic>
        {title}
      </H5>
      <Rule colour={`teal`} />
      <StyledRow withWrap gutter>
        {packages?.map(({ id, level, content, cost }) => (
          <StyledColumn key={id} gutter width={`md:1/2`}>
            <Title colour={`navy`} withSpacing={`sm`}>
              {level}
            </Title>
            <Content withSpacing>{content}</Content>
            <P withSpacing={`sm`}>{locales?.additionalPackageCostEstimation}</P>
            <Pricing items={`end`} justify={`start`}>
              <Cost as={`p`} colour={`navy`} italic>
                {cost}
              </Cost>
              <P>{locales?.additionalPackageCostTimeline}</P>
            </Pricing>
          </StyledColumn>
        ))}
      </StyledRow>
    </Section>
  )
)

export default Packages
